import "./App.css";

function App() {
  function clock() {
    let time = new Date();
    let hour = time.getHours();
    let min = time.getMinutes();
    let sec = time.getSeconds();

    let hrotation = 30 * hour + min / 2;
    let mrotation = 6 * min;
    let srotation = 6 * sec;

    let hr = document.getElementById("hour");
    let mr = document.getElementById("min");
    let sr = document.getElementById("sec");
    hr.style.transform = `rotate(${hrotation}deg)`;
    mr.style.transform = `rotate(${mrotation}deg)`;
    sr.style.transform = `rotate(${srotation}deg)`;
  }

  setInterval(clock, 1000);

  return (
    <>
      <div className="main--container">
        <h1 style={{ textAlign: "center", color: "white", fontSize: "4rem" }}>
          Analog Clock
        </h1>
        <div className="clock">
          <div className="hand" id="hour"></div>
          <div className="hand" id="min"></div>
          <div className="hand" id="sec"></div>
        </div>
      </div>
    </>
  );
}

export default App;
